{
	"flag": "🇺🇸",
	"common": {
		"yes": "Yes",
		"no": "No",
		"username": "Username",
		"password": "Password",
		"e-mail": "E-mail",
		"edit": "Edit",
		"add": "Add",
		"selected": "Selected",
		"select": "Select",
		"select-all": "Select all",
		"selected-all": "Selected all",
		"sign-out": "Log out",
		"or": "Or",
		"create": "Create",
		"save": "Save",
		"language": "Language",
		"saving": "Saving",
		"delete": "Delete",
		"next": "Next",
		"get-started": "Get Started",
		"skip": "Skip",
		"optional": "optional",
		"read-more": "Read more",
		"show-less": "Show less",
		"cancel": "Cancel",
		"search": "Search",
		"send": "Send",
		"done": "Done",
		"password-requirements-hint": "Min {{minLength}} characters, one number, one special character",
		"enter-your-email": "Enter your email",
		"enter-your-username": "Enter your username",
		"create-a-password": "Create a password",
		"enter-your-password": "Enter your password"
	},
	"login": {
		"welcome-back": "Welcome back to Pletly",
		"to-keep-connected-with-us-please-login-to-your-account": "Log in to continue being a valued part of our caring community",
		"forgot-password": "Forgot password?",
		"sign-in": "Log in",
		"sign-up": "Sign up",
		"dont-have-an-account": "Don't have an account?",
		"please-enter-your-email-an-email-will-be-sent-to-it-to-reset-your-password": "Please enter your email, an email will be sent to it to reset your password",
		"set-new-password": "Set new password",
		"create-new-password": "Create new password",
		"password-updated": "Password updated",
		"your-password-has-been-successfully-changed": "Your password has been successfully changed.",
		"password-set-successfully": "Password set successfully",
		"you-can-login-now": "You can login now"
	},
	"register": {
		"create-account": "Create Account",
		"repeat-password": "Repeat password",
		"do-you-have-account": "Do you have an account?",
		"agree-to": "By creating an account, you agree to our",
		"privacy-policy-and-eula": "Privacy Policy and EULA",
		"hello-friend": "Greetings from the Pletly family!",
		"provide-your-personal-details": "Share your details and join us in our journey of care and support.",
		"sign-up-for-a-newsletter": "Subscribe to our newsletter and become part of our community!"
	},
	"forgot-password": {
		"sent-please-check-your-email": "Sent, please check your email"
	},
	"profile": {
		"delete-account": "Delete account",
		"this-action-cannot-be-undone": "This action cannot be undone"
	},
	"validations": {
		"error": "Error"
	},
	"change-password": {
		"modal": {
			"title": "Change password",
			"submit": "Change password"
		},
		"old-password": "Old password",
		"new-password": "New password",
		"repeat-new-password": "Repeat new password",
		"invalid-password": "Invalid password",
		"password-changed": "Password has been changed",
		"passwords-do-not-match": "Passwords do not match",
		"new-password-must-be-different-from-the-old-one": "New password must be different from the previous one"
	}
}
